import PropTypes from "prop-types";
import { CustomContainer } from "../../../DependencyHelper";
import formStyles from "../CreditCheckDetails.module.scss";

const PersonalDetailsInfo = ({ data }) => {
  return (
    <CustomContainer className={`${formStyles["form-details-container"]}`}>
      <CustomContainer className="row">
        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Title:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.title}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Initials:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.initials}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>First name:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.firstName}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Surname:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.surName}</span>
        </CustomContainer>

        <CustomContainer className={`${formStyles["pb-6"]} col-md-6 col-sm-12`}>
          <label>Marital status:</label>
        </CustomContainer>
        <CustomContainer className={`col-md-6 col-sm-12`}>
          <span>{data?.maritalStatus}</span>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  );
};

PersonalDetailsInfo.propTypes = {
  data: PropTypes.object,
};

PersonalDetailsInfo.defaultProps = {
  data: {},
};

export default PersonalDetailsInfo;
